import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';

import { extractAcronym } from 'domain/domain.utils';

export class JobOfferModuleColumn {
	readonly moduleColumnId: string;
	readonly organizationModuleId: string;
}

export interface IJobOffer extends IEntity {
	readonly title: string;
	readonly ownerId: string;
	readonly keyPoints: string;
	readonly companyName: string;
	readonly documentUrl: string;
	readonly contractType: string;
	readonly modulesColumn: JobOfferModuleColumn[];
	readonly acronym: string;

	isInColumn(columnId: string): boolean;
}

export class JobOffer extends Entity implements IJobOffer {
	private _title: string;
	private _ownerId: string;
	private _keyPoints: string;
	private _companyName: string;
	private _documentUrl: string;
	private _contractType: string;
	private _modulesColumn: JobOfferModuleColumn[];
	private _acronym: string;

	constructor(
		id: string,
		title: string,
		ownerId: string,
		keyPoints: string,
		companyName: string,
		documentUrl: string,
		contractType: string,
		modulesColumn: JobOfferModuleColumn[]
	) {
		super(id);
		this._title = title;
		this._ownerId = ownerId;
		this._keyPoints = keyPoints;
		this._companyName = companyName;
		this._documentUrl = documentUrl;
		this._contractType = contractType;
		this._modulesColumn = modulesColumn;

		this._acronym = extractAcronym(this._title);
	}

	public get title(): string {
		return this._title;
	}

	public get ownerId(): string {
		return this._ownerId;
	}

	public get keyPoints(): string {
		return this._keyPoints;
	}

	public get companyName(): string {
		return this._companyName;
	}

	public get documentUrl(): string {
		return this._documentUrl;
	}

	public get contractType(): string {
		return this._contractType;
	}

	public get modulesColumn(): JobOfferModuleColumn[] {
		return this._modulesColumn;
	}

	public get acronym(): string {
		return this._acronym;
	}

	public isInColumn(moduleColumnId: string): boolean {
		return (this.modulesColumn || []).some(
			(c) => c.moduleColumnId === moduleColumnId
		);
	}
}
